export default __webpack_public_path__ + "static/media/0372.d63d18bf.jpg";